import {FC} from 'react'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {useLimpieza} from '../../../../../hooks/useLimpieza'
import ContainerWrapper from '../../componentes/Container'
import {renderPanelContent} from '../components'

const ReportCensusHistoryPageWrapper: FC = () => {
  const {currentTabItem} = useLimpieza()
  return (
    <ContainerWrapper>
      <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
        <Panel
          collapsible={true}
          order={1}
          key={`panel-limpieza-header-${currentTabItem.id}`}
          id={`panel-limpieza-header-${currentTabItem.id}`}
          className={'panel__box'}
          defaultSize={50}
        >
          <>{renderPanelContent(currentTabItem.content.headerPanel)}</>
        </Panel>
      </PanelGroup>
    </ContainerWrapper>
  )
}

export {ReportCensusHistoryPageWrapper}
